import { queryOptions, useMutation, useQuery } from "@tanstack/react-query";
import bomSupplierInfoService from "../services/bom-supplier-info-service";
import type { CreateBomSupplierInfoData, UpdateBomSupplierInfoData } from "../../types/bom-supplier-info";
import { queryClient } from "@/query-client";

export const bomSupplierInfosQueryOptions = (params: Record<string, unknown> = {}) =>
    queryOptions({
        queryKey: ["bom-supplier-infos", params],
        queryFn: () => bomSupplierInfoService.list(params),
    });

export const bomSupplierInfoOptionsQueryOptions = () =>
    queryOptions({
        queryKey: ["bom-supplier-infos", "options"],
        queryFn: () => bomSupplierInfoService.options(),
        staleTime: 1000 * 60 * 60,
    });

export const useBomSupplierInfoOptions = () => {
    const query = useQuery(bomSupplierInfoOptionsQueryOptions());
    const options = (query.data ?? []).map((s) => ({
        value: s.id,
        label: s.supplier_name ?? "—",
    }));
    return { ...query, options };
};

export const bomSupplierInfoQueryOptions = (id: string) =>
    queryOptions({
        queryKey: ["bom-supplier-info", id],
        queryFn: () => bomSupplierInfoService.findById(id),
    });

export const useBomSupplierInfoCreateMutation = () =>
    useMutation({
        mutationFn: (data: CreateBomSupplierInfoData) => bomSupplierInfoService.create(data),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ["bom-supplier-infos"] });
        },
    });

export const useBomSupplierInfoUpdateMutation = (id: string) =>
    useMutation({
        mutationFn: (data: UpdateBomSupplierInfoData) => bomSupplierInfoService.updateById(id, data),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ["bom-supplier-infos"] });
        },
    });

export const useBomSupplierInfoDeleteMutation = () =>
    useMutation({
        mutationFn: (id: string) => bomSupplierInfoService.deleteById(id),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ["bom-supplier-infos"] });
        },
    });
